import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import MainLayout from "@/views/Layout/MainLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

const Dash = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");

const MainAdmin = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");

const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");

/*********Mancave-categories**********/
const categories = () => import("@/views/ManCave/Categories.vue");

const services = () => import("@/views/ManCave/services.vue");

const shifts = () => import("@/views/ManCave/timeSlots.vue");

const promoCodes = () => import("@/views/ManCave/promoCodes.vue");

const shopTimings = () => import("@/views/ManCave/shopTimings.vue");

const staff = () => import("@/views/ManCave/staff.vue");

const flags = () => import("@/views/ManCave/flags.vue");

const holidays = () => import("@/views/ManCave/Holidays.vue");

const bookings = () => import("@/views/ManCave/Bookingss.vue");

const notifications = () => import("@/views/ManCave/notifications.vue");

let myMenu = {
  path: "/fusion",
  component: MainLayout,
  name: "fusion",
  redirect: "/fusion/dashboard",
  children: [
    {
      path: "dashboard",
      name: "fusiondashboard",
      component: Dash,
    },
    {
      path: "admin",
      name: "fusiondashboard",
      component: MainAdmin,
    },

    /*****Mancave*******/
    {
      path: "categories",
      name: "categories",
      component: categories,
    },
    {
      path: "services",
      name: "services",
      component: services,
    },
    {
      path: "promoCodes",
      name: "promoCodes",
      component: promoCodes,
    },
    {
      path: "shopTimings",
      name: "shopTimings",
      component: shopTimings,
    },
    {
      path: "staff",
      name: "staff",
      component: staff,
    },
    {
      path: "flags",
      name: "flags",
      component: flags,
    },
    {
      path: "appointments",
      name: "appointments",
      component: bookings,
    },
    {
      path: "shifts",
      name: "shifts",
      component: shifts,
    },
    {
      path: "notifications",
      name: "notifications",
      component: notifications,
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    { path: "*", name: "404", component: NotFound },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Home",
  },
  myMenu,
  authPages,
];

export default routes;
